export var EventLinkType = {
  APP_MAGALU: 'app-magalu',
  INFLUENCIADOR_MAGALU: 'influenciador-magalu'
};
export var SessionStorageItem = {
  MAGALY: 'shorten_magaly',
  ONELINK: 'shorten_onelink'
};
export var ShortenLinkTypes = {
  MAGALY: 'shortenlink-magaly',
  ONELINK: 'shortenlink-onelink'
};
export var TabDescription = {
  APP_MAGALU: 'Esse link de afiliado direciona o cliente para o app do Magalu, caso o cliente não tenha o app irá para sua loja no site Magazinevoce.',
  INFLUENCIADOR_MAGALU: 'Esse link direciona para sua loja no site Magazinevoce.',
  OFFER_MAGALU: 'Esse link de afiliado direciona o cliente para o app do Magalu, caso o cliente não tenha o app irá para o site do magazineluiza.com.br.'
};
export var TabTitle = {
  APP_MAGALU: 'App Magalu',
  INFLUENCIADOR_MAGALU: 'Influenciador Magalu'
};